<dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'" class="input-box-section"
    style="padding: 0.5rem 1rem; margin-bottom: 1rem">
    <dxi-item [ratio]="6" class="separate-input-field">
        <!-- <label class="lable" for="FinancialYearRef">Financial Year</label> -->
        <label class="lable" for="FinancialYearRef">
            {{ langService.currentLang === 'mr' ? 'आर्थिक वर्ष' : 'Financial Year' }}
        </label>
        <dx-select-box id="FinancialYearRef" [(ngModel)]="DashboardFilterService.FinancialYearRef" [items]="YearsList"
            displayExpr="p.short_name" valueExpr="p.id" name="FinancialYearRef"
            placeholder="{{ 'REPORT_PLACEHOLDERS.Select' | translate }}"
            [inputAttr]="{ 'aria-label': 'FinancialYearRef' }" style="width: 100%" [searchEnabled]="true"
            class="inputfield" (onValueChanged)="onYearChanged($event)">
        </dx-select-box>
    </dxi-item>
    <dxi-item [ratio]="6" class="separate-input-field">
        <!-- <label class="lable" for="FilterRef">Filter Type</label> -->
        <label class="lable" for="FilterRef">
            {{ langService.currentLang === 'mr' ? 'फिल्टर प्रकार' : 'Filter Type' }}
        </label>
        <dx-select-box id="FilterRef" [(ngModel)]="DashboardFilterService.ReportFilterType" [items]="FilterList"
            [displayExpr]="getTranslatedName" valueExpr="Ref" name="Role"
            placeholder="{{ 'REPORT_PLACEHOLDERS.Select' | translate }}" [inputAttr]="{ 'aria-label': 'FilterRef' }"
            style="width: 100%" [searchEnabled]="true" class="inputfield"
            (onValueChanged)="OnFilterChange(DashboardFilterService.ReportFilterType)">
        </dx-select-box>
    </dxi-item>
    <dxi-item [ratio]="6" class="separate-input-field"
        [visible]="!IsShowMonth && !IsShowDates && !IsShowQuarter && !IsShowHalfYear">
    </dxi-item>
    <dxi-item [ratio]="6" class="separate-input-field" [visible]="IsShowHalfYear">
        <!-- <label for="HalfYear" class="lable">Half Year</label> -->
        <label for="HalfYear" class="lable">
            {{ 'FILTER_LABELS.HalfYear' | translate }}
        </label>
        <dx-select-box id="HalfYear" [(ngModel)]="DashboardFilterService.HalfYearType" [items]="HalfYearList"
            [displayExpr]="getTranslatedName" valueExpr="Ref" name="HalfYear"
            [placeholder]="'REPORT_PLACEHOLDERS.SelectHalfYear' | translate" [inputAttr]="{ 'aria-label': 'HalfYear' }"
            style="width: 100%" [searchEnabled]="true" class="inputfield" (onValueChanged)="onHalfYearChanged($event)">
        </dx-select-box>
    </dxi-item>
    <dxi-item [ratio]="6" class="separate-input-field" [visible]="IsShowQuarter">
        <!-- <label for="Quarter" class="lable">Quarter</label> -->
        <label for="Quarter" class="lable">
            {{ 'FILTER_LABELS.Quarter' | translate }}
        </label>
        <dx-select-box id="Quarter" [(ngModel)]="DashboardFilterService.QuarterlyYearType" [items]="QuarterList"
            [displayExpr]="getTranslatedName" valueExpr="Ref" name="Quarter"
            placeholder="{{ 'REPORT_PLACEHOLDERS.SelectQuarter' | translate }}"
            [inputAttr]="{ 'aria-label': 'Quarter' }" style="width: 100%" [searchEnabled]="true" class="inputfield"
            (onValueChanged)="onQuarterChanged($event)">
        </dx-select-box>
    </dxi-item>
    <dxi-item [ratio]="6" class="separate-input-field" [visible]="IsShowMonth">
        <!-- <label for="Month" class="lable">Month</label> -->
        <label for="Month" class="lable">
            {{ 'FILTER_LABELS.Month' | translate }}
        </label>
        <dx-select-box id="Month" [(ngModel)]="DashboardFilterService.Month" [items]="MonthList"
            [displayExpr]="getTranslatedName" valueExpr="Ref" name="Month"
            [placeholder]="'REPORT_PLACEHOLDERS.SelectMonth' | translate" [inputAttr]="{ 'aria-label': 'Month' }"
            style="width: 100%" [searchEnabled]="true" class="inputfield" (onValueChanged)="onMonthChanged($event)">
        </dx-select-box>
    </dxi-item>
    <!-- <dxi-item [ratio]="6" class="separate-input-field" [visible]="IsShowDates">
        <label for="FromDate" class="lable">From Date</label>
        <dx-date-box [(ngModel)]="FromDate" displayFormat="dd/MM/yyyy" [showClearButton]="true" [useMaskBehavior]="true"
            [width]="'100%'" stylingMode="outlined" placeholder="DD/MM/YYYY"
            [calendarOptions]="{ showTodayButton: true }" class="inputfield" [min]="financialYearStart"
            [max]="financialYearEnd">
        </dx-date-box>
    </dxi-item>
    <dxi-item [ratio]="6" class="separate-input-field" [visible]="IsShowDates">
        <label for="ToDate" class="lable">To Date</label>
        <dx-date-box displayFormat="dd/MM/yyyy" [(ngModel)]="ToDate" [showClearButton]="true" [useMaskBehavior]="true"
            [width]="'100%'" stylingMode="outlined" placeholder="DD/MM/YYYY"
            [calendarOptions]="{ showTodayButton: true }" class="inputfield" [min]="financialYearStart"
            [max]="financialYearEnd" (onValueChanged)="OnDateChange(FromDate,ToDate)">
        </dx-date-box>
    </dxi-item> -->

    <!-- <dxi-item [ratio]="1" [baseSize]="'auto'" [shrink]="1">
        <div class="input-field" style="display: flex; justify-content: flex-end; margin-top: 20px; width: 100%">
            <app-generate-report text="Generate"></app-generate-report>
        </div>
    </dxi-item> -->

    <!-- Right: Filter + Export Buttons -->
    <dxi-item [ratio]="1">
        <div class="filter-container">

            <!-- <button class="menu-button" (click)="toggleFilterPopup()"
                style="background: none; border: none; cursor: pointer; display: flex; justify-content: flex-end; margin-top: 20px">
                <img src="assets/icons/filter_pink.png" alt="Toggle Menu" style="width: 34px; height: 34px" />
            </button> -->

            <!-- Custom Popup (div-based) -->
            <div class="custom-filter-popup" *ngIf="isFilterActive" (wheel)="$event.stopPropagation()">
                <div class="filter-header-row">
                    <div class="filter-header">Filter Report by</div>
                    <span class="modal-close" (click)="isFilterActive = false">
                        <img src="./assets/icons/close.png" alt="close" />
                    </span>
                </div>
                <dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'"
                    class="input-box-section" style="margin-bottom: 1rem">
                    <dxi-item [ratio]="6" class="separate-input-field">
                        <label class="lable" for="StateRef">State</label>
                        <dx-tag-box id="StateRef" [(ngModel)]="DashboardFilterService.state_ids"
                            [items]="DashboardFilterService.StateList"
                            [disabled]="DashboardFilterService.IsStateDisabled || true" displayExpr="p.NameEn"
                            class="inputfield" valueExpr="p.Ref" name="StateRef" placeholder="All State"
                            [inputAttr]="{ 'aria-label': 'State' }" style="width: 100%" [showSelectionControls]="true"
                            [searchEnabled]="true" [showClearButton]="true" [showDropDownButton]="true"
                            [dropDownOptions]="{ container: '.filter-container' }" [maxDisplayedTags]="1"
                            (onValueChanged)="onStateChanged($event)">
                        </dx-tag-box>
                    </dxi-item>

                    <dxi-item [ratio]="6" class="separate-input-field">
                        <label class="lable" for="ZoneRef">Zone</label>
                        <dx-tag-box id="ZoneRef" [(ngModel)]="DashboardFilterService.zone_ids"
                            [items]="DashboardFilterService.ZoneList"
                            [disabled]="DashboardFilterService.IsZoneDisabled || true" displayExpr="p.Name"
                            valueExpr="p.Ref" name="ZoneRef" placeholder="All Zone"
                            [inputAttr]="{ 'aria-label': 'Zone' }" [showDropDownButton]="true" class="inputfield"
                            style="width: 100%" [showSelectionControls]="true" [searchEnabled]="true"
                            [showClearButton]="true" (onValueChanged)="onZoneChanged($event)" [maxDisplayedTags]="1"
                            [dropDownOptions]="{ container: '.filter-container' }">
                        </dx-tag-box>
                    </dxi-item>
                </dx-box>

                <dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'"
                    class="input-box-section" style="margin-bottom: 1rem">
                    <dxi-item [ratio]="6" class="separate-input-field">
                        <label class="lable" for="DistrictRef">District</label>
                        <dx-tag-box id="DistrictRef" [(ngModel)]="DashboardFilterService.district_ids"
                            [items]="DashboardFilterService.DistrictList || true"
                            [disabled]="DashboardFilterService.IsDistrictDisabled" displayExpr="p.NameEn"
                            valueExpr="p.Ref" name="DistrictRef" placeholder="All District" class="inputfield"
                            [inputAttr]="{ 'aria-label': 'District' }" style="width: 100%" [showDropDownButton]="true"
                            [showSelectionControls]="true" [searchEnabled]="true" [showClearButton]="true"
                            (onValueChanged)="onDistrictChanged($event)" [maxDisplayedTags]="1"
                            [dropDownOptions]="{ container: '.filter-container' }">
                        </dx-tag-box>
                    </dxi-item>


                    <dxi-item [ratio]="6" class="separate-input-field">
                        <label class="lable" for="BlockRef">Block</label>
                        <dx-tag-box id="BlockRef" [(ngModel)]="DashboardFilterService.block_ids"
                            [items]="DashboardFilterService.BlockList" displayExpr="p.NameEn" valueExpr="p.Ref"
                            [disabled]="DashboardFilterService.IsBlockDisabled" placeholder="All Block"
                            class="inputfield" style="width: 100%" [showDropDownButton]="true"
                            [showSelectionControls]="true" [searchEnabled]="true" [showClearButton]="true"
                            [dropDownOptions]="{ container: '.filter-container' }"
                            (onValueChanged)="onBlockChanged($event)" [maxDisplayedTags]="1"></dx-tag-box>
                    </dxi-item>
                </dx-box>

                <dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'"
                    class="input-box-section" style="margin-bottom: 1rem">

                    <dxi-item [ratio]="6" class="separate-input-field">
                        <label class="lable" for="BCMPostRef">BCM Name</label>
                        <dx-tag-box id="BCMPostRef" [(ngModel)]="DashboardFilterService.bcm_post_ids"
                            [items]="DashboardFilterService.BCMPostList" displayExpr="p.Name" valueExpr="p.Ref"
                            [disabled]="DashboardFilterService.IsBCMPostDisabled" placeholder="All BCM"
                            [showDropDownButton]="true" class="inputfield" style="width: 100%"
                            [showSelectionControls]="true" [searchEnabled]="true" [showClearButton]="true"
                            [dropDownOptions]="{ container: '.filter-container' }"
                            (onValueChanged)="onBCMPostChanged($event)" [maxDisplayedTags]="1"></dx-tag-box>
                    </dxi-item>

                    <dxi-item [ratio]="6" class="separate-input-field">
                        <label class="lable" for="PHCRef">PHC</label>
                        <dx-tag-box id="PHCRef" [(ngModel)]="DashboardFilterService.phc_ids"
                            [items]="DashboardFilterService.PHCList" displayExpr="p.Name" valueExpr="p.Ref"
                            placeholder="All PHC" class="inputfield" style="width: 100%" [showSelectionControls]="true"
                            [searchEnabled]="true" [showDropDownButton]="true" [showClearButton]="true"
                            [disabled]="DashboardFilterService.IsPHCDisabled"
                            [dropDownOptions]="{ container: '.filter-container' }"
                            (onValueChanged)="onPHCChanged($event)" [maxDisplayedTags]="1"></dx-tag-box>
                    </dxi-item>

                </dx-box>

                <dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'"
                    class="input-box-section" style="margin-bottom: 1rem">

                    <dxi-item [ratio]="6" class="separate-input-field">
                        <label class="lable" for="AFPostRef">AF</label>
                        <dx-tag-box id="AFPostRef" [(ngModel)]="DashboardFilterService.af_ids"
                            [items]="DashboardFilterService.AFList" displayExpr="p.Name" valueExpr="p.Ref"
                            placeholder="All AF" class="inputfield" style="width: 100%" [showSelectionControls]="true"
                            [searchEnabled]="true" [showDropDownButton]="true" [showClearButton]="true"
                            [disabled]="DashboardFilterService.IsAFPostDisabled"
                            [dropDownOptions]="{ container: '.filter-container' }"
                            (onValueChanged)="onAFPostChanged($event)" [maxDisplayedTags]="1"></dx-tag-box>
                    </dxi-item>

                    <dxi-item [ratio]="6" class="separate-input-field">
                        <label class="lable" for="SCRef">SC</label>
                        <dx-tag-box id="SCRef" [(ngModel)]="DashboardFilterService.sc_ids"
                            [items]="DashboardFilterService.SCList" displayExpr="p.Name" valueExpr="p.Ref" name="SCRef"
                            placeholder="All SC" [inputAttr]="{ 'aria-label': 'SC' }" class="inputfield"
                            style="width: 100%" [showDropDownButton]="true" [showSelectionControls]="true"
                            [searchEnabled]="true" [showClearButton]="true"
                            [dropDownOptions]="{ container: '.filter-container' }"
                            [disabled]="DashboardFilterService.IsSCDisabled" (onValueChanged)="onSCChanged($event)"
                            [maxDisplayedTags]="1">
                        </dx-tag-box>
                    </dxi-item>
                </dx-box>

                <dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'"
                    class="input-box-section" style="margin-bottom: 1rem">
                    <dxi-item [ratio]="6" class="separate-input-field">
                        <label class="lable" for="VillageRef">Village</label>
                        <dx-tag-box id="VillageRef" [(ngModel)]="DashboardFilterService.village_ids"
                            [items]="DashboardFilterService.VillageList" displayExpr="p.NameEn" valueExpr="p.Ref"
                            name="VillageRef" placeholder="All Village" [inputAttr]="{ 'aria-label': 'Village' }"
                            [disabled]="DashboardFilterService.IsVillageDisabled" class="inputfield" style="width: 100%"
                            [showSelectionControls]="true" [searchEnabled]="true" [showClearButton]="true"
                            [dropDownOptions]="{ container: '.filter-container' }" [showDropDownButton]="true"
                            (onValueChanged)="onVillageChanged($event)" [maxDisplayedTags]="1">
                        </dx-tag-box>
                    </dxi-item>

                    <dxi-item [ratio]="6" class="separate-input-field">
                        <label class="lable" for="AshaRefs">Asha</label>
                        <dx-tag-box id="AshaRefs" [(ngModel)]="DashboardFilterService.asha_ids"
                            [items]="DashboardFilterService.AshaList" displayExpr="p.AshaFullName" valueExpr="p.Ref"
                            name="AshaRefs" placeholder="All Asha" [inputAttr]="{ 'aria-label': 'Asha' }"
                            [disabled]="DashboardFilterService.IsAshaDisabled" class="inputfield" style="width: 100%"
                            [showSelectionControls]="true" [searchEnabled]="true" [showClearButton]="true"
                            [dropDownOptions]="{ container: '.filter-container' }" [showDropDownButton]="true"
                            (onValueChanged)="onAshaChanged($event)" [maxDisplayedTags]="1"></dx-tag-box>
                    </dxi-item>
                </dx-box>
                <!-- Apply Button -->
                <div class="apply-btn-container">
                    <dxi-item [ratio]="1" [baseSize]="'auto'" [shrink]="1">
                        <div class="input-field" style="display: flex; justify-content: flex-end; width: 100%">
                            <dx-button [elementAttr]="{ class: 'filter-button' }" text="Apply" type="default"
                                stylingMode="contained" (click)="applyFilters()">
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item [ratio]="1" [baseSize]="'auto'" [shrink]="1">
                        <div class="input-field" style="display: flex; justify-content: flex-end; width: 100%">
                            <dx-button [elementAttr]="{ class: 'filter-button' }" text="Clear" type="default"
                                stylingMode="contained" (click)="clearFilters()">
                            </dx-button>
                        </div>
                    </dxi-item>
                </div>
            </div>
        </div>
    </dxi-item>
</dx-box>

<div class="rural-urban-toggle">
    <div class="toggle-option" [class.active]="selectedArea === 'rural'" (click)="onAreaChange('rural')">
        {{ langService.currentLang === 'mr' ? 'ग्रामीण' : 'Rural' }}
    </div>

    <div class="toggle-option" [class.active]="selectedArea === 'urban'" (click)="onAreaChange('urban')">
        {{ langService.currentLang === 'mr' ? 'शहरी' : 'Urban' }}
    </div>
</div>

<!-- ✅ GLOBAL NO DATA STATE -->
<div *ngIf="isUrbanNoData" class="global-empty-state">
    <div class="empty-card">
        <div class="empty-icon">📊</div>
        <!-- <div class="empty-title">
            {{ langService.currentLang === 'mr'
            ? 'माहिती उपलब्ध नाही'
            : 'No Data Available' }}
        </div> -->
        <div class="empty-subtitle">
            {{ langService.currentLang === 'mr'
            ? 'शहरी क्षेत्रासाठी माहिती उपलब्ध नाही'
            : 'No data available for Urban area' }}
        </div>
    </div>
</div>



<div *ngIf="!isUrbanNoData">

    <div class="dashboard-container">

        <!-- Cards Row -->
        <!-- <div class="cards-row" *ngIf="LoginEmployeeRole !== Roles.Asha"> -->
        <div class="cards-row">
            <!-- <div class="card card-one">
            <div class="value" id="approvedfamilies">0</div>
            <div class="label"> {{ langService.currentLang === 'mr' ? 'मंजूर कुटुंबे' : 'Approved Families' }}</div>
        </div> -->
            <!-- <div class="card card-two">
            <div class="value" id="pendingfamilies">0</div>
            <div class="label"> {{ langService.currentLang === 'mr' ? 'प्रलंबित कुटुंबे' : 'Pending Families' }}</div>
        </div> -->
            <!-- <div class="card card-topfive" (click)="getTopFiveAshaIncentive()">
            <div class="value" id="TopFive">0</div>
            <div class="label">{{ langService.currentLang === 'mr' ? 'दुरुस्तीसाठी परत केलेली कुटुंबे' : 'Returned for Correction Families' }}</div>
        </div> -->
        </div>


        <!-- Performance card below-->
        <div class="card asha-performance-card">
            <!-- <div class="asha-performance-title">Family Registration</div> -->
            <div class="asha-performance-title">
                {{ langService.currentLang === 'mr' ? 'कुटुंब नोंदणी' : 'Family Registration' }}
            </div>

            <div class="cards-row">
                <div class="card card-one">
                    <div class="value" id="totalmemberscount">0</div>
                    <div class="label"> {{ langService.currentLang === 'mr' ? 'आशा द्वारे समाविष्ट एकूण लोकसंख्या' : 'Total Population Coverd By Asha'}}
                    </div>
                </div>
                <div class="card card-two">
                    <div class="value" id="nooffamilies">0</div>
                    <div class="label"> {{ langService.currentLang === 'mr' ? 'कुटुंबांची संख्या' : 'No. of Families' }}
                    </div>
                </div>
                <div class="card card-three">
                    <div class="value" id="noofchildernbelowfiveyears">0</div>
                    <div class="label"> {{ langService.currentLang === 'mr' ? '0 ते 5 वर्षे वयोगटातील मुले' : 'Children
                        (0–5
                        yrs)' }}</div>
                </div>
                <div class="card card-four">
                    <div class="value" id="noofmembersabovethirtyyears">0</div>
                    <div class="label"> {{ langService.currentLang === 'mr' ? '३० वर्षांवरील सदस्य' : 'Members Above 30
                        years' }}</div>
                </div>
                <div class="card card-five"  *ngIf="LoginEmployeeRole !== Roles.Asha">
                <div class="value" id="approvedfamilies">0</div>
                <div class="label"> {{ langService.currentLang === 'mr' ? 'मंजूर कुटुंबे' : 'Approved Families' }}</div>
            </div> 
            <div class="card card-six"  *ngIf="LoginEmployeeRole !== Roles.Asha">
                <div class="value" id="pendingfamilies">0</div>
                <div class="label"> {{ langService.currentLang === 'mr' ? 'प्रलंबित कुटुंबे' : 'Pending Families' }}</div>
            </div> 
            </div>

          

        </div>

    </div>

    <div class="dashboard-container">
      
        <div class="charts-row">
            <!-- 3rd bar chart -->
            <!-- monthly incentive of asha data -->

              <!-- pie chart of Family Folder -->
            <div class="chart-card card">
                <dx-pie-chart [dataSource]="familyStatusData"
                    [palette]="['#6d45a1', '#4f71d6', '#2eacd5', '#69cfd8', '#a78ed4']" style="height: 300px;"
                    style="height: 300px;">
                    <dxo-animation [enabled]="true" [duration]="1000" easing="easeOutCubic">
                    </dxo-animation>
                    <dxo-size [height]="300"></dxo-size>
                    <dxo-title [text]="langService.currentLang === 'mr'
                ? 'कुटुंब स्थिती वितरण' : 'Family Status Distribution'">
                        <dxo-font color="#0077d4" size="18" family="Arial" weight="bold"></dxo-font>
                        <dxo-margin [top]="20" [bottom]="10"></dxo-margin>
                    </dxo-title>

                    <dxi-series argumentField="Name" valueField="Value" innerRadius="0.4">
                        <dxo-label [visible]="false"></dxo-label>
                    </dxi-series>

                    <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltipFamily">
                    </dxo-tooltip>
                    <dxo-legend verticalAlignment="bottom" horizontalAlignment="center"></dxo-legend>
                    <dxo-export [enabled]="true"></dxo-export>
                </dx-pie-chart>
            </div>
            <div class="card chart-card">
                <dx-chart #TrainingCompletionChart [dataSource]="PNCRegisterData"
                    (onLegendClick)="onLegendClick($event)" style="height: 400px; width: 100% ; padding: 0.8rem;"
                    (onPointClick)="onBarClick($event)">

                    <dxo-title [text]="langService.currentLang === 'mr'
            ? 'गर्भवती महिला (एएनसी)'
            : 'Pregnant Women (ANC)'">>

                        <dxo-font color="#0077d4" size="18" family="Arial" weight="bold"></dxo-font>
                        <dxo-margin [top]="20" [bottom]="10"></dxo-margin>
                    </dxo-title>

                    <!-- Argument field must match X-axis property -->
                    <dxo-common-series-settings argumentField="Name" type="bar"></dxo-common-series-settings>

                    <!-- One series generated from TrainingCompletionList -->
                    <dxi-series valueField="Value" argumentField="Name" name="Risk Count" color="#FFD93D">
                    </dxi-series>
                    <dxo-legend verticalAlignment="bottom" horizontalAlignment="center"></dxo-legend>
                    <dxo-tooltip [enabled]="true"></dxo-tooltip>
                    <dxo-export [enabled]="true"></dxo-export>
                </dx-chart>

                
            </div>


          
        </div>



        
        <!-- Performance card below-->
        <div class="card asha-performance-card" *ngIf="LoginEmployeeRole !== Roles.Asha">
            <div class="asha-performance-title">
                {{ langService.currentLang === 'mr' ? 'आशा कार्यप्रदर्शन' : 'Asha Performance' }}
            </div>
             <!-- Cards Row -->
        <div class="cards-row" *ngIf="LoginEmployeeRole !== Roles.Asha">
            <div class="card card-one" (click)="getAshaRegistered()">
                <div class="value">0</div>
                <!-- <div class="label">Total ASHAs Registered</div> -->
                <div class="label">
                    {{ langService.currentLang === 'mr'
                    ? 'नोंदणीकृत आशांची एकूण संख्या'
                    : 'Total ASHAs Registered' }}
                </div>
            </div>
            <div class="card card-two" (click)="getAshaTrained()">
                <div class="value">0</div>
                <!-- <div class="label">Total ASHAs Trained</div> -->
                <div class="label">
                    {{ langService.currentLang === 'mr'
                    ? 'प्रशिक्षित आशांची एकूण संख्या'
                    : 'Total ASHAs Trained' }}
                </div>
            </div>
            <div class="card card-topfive" (click)="getTopFiveAshaIncentive()">
                <div class="value">0</div>
                <!-- <div class="label">Top 5 Asha Performed</div> -->
                <div class="label">
                    {{ langService.currentLang === 'mr'
                    ? 'उत्कृष्ट ५ आशा कामगिरी'
                    : 'Top 5 ASHA Performed' }}
                </div>
            </div>
            <div class="card card-ZeroIncentive" (click)="onAshaPerformanceChanged('ZeroPerformance')">
                    <div class="value">0</div>
                    <!-- <div class="label">Zero Performance</div> -->
                    <div class="label">
                        {{ langService.currentLang === 'mr'
                        ? 'शून्य कामगिरी'
                        : 'Zero Performance' }}
                    </div>
                </div>
                <div class="card card-three" (click)="onAshaPerformanceChanged('LowPerformance')">
                    <div class="value">0</div>
                    <!-- <div class="label">Low Performance</div> -->
                    <div class="label">
                        {{ langService.currentLang === 'mr'
                        ? 'कमी कामगिरी'
                        : 'Low Performance' }}
                    </div>
                </div>
                <div class="card card-four" (click)="onAshaPerformanceChanged('TopPerformance')">
                    <div class="value" >0</div>
                    <!-- <div class="label">Top Performance</div> -->
                    <div class="label">
                        {{ langService.currentLang === 'mr'
                        ? 'उत्कृष्ट कामगिरी'
                        : 'Top Performance' }}
                    </div>
                </div>
                <div class="card card-five" (click)="onAshaPerformanceChanged('IncentiveAnalysis')">
                    <div class="value" >0</div>
                    <!-- <div class="label">Incentive Analysis</div> -->
                    <div class="label">
                        {{ langService.currentLang === 'mr'
                        ? 'प्रोत्साहन विश्लेषण'
                        : 'Incentive Analysis' }}
                    </div>
                </div>
        </div>

        </div>


            </div>

        </div>